import LandingPage from '../components/landing-page'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { withTranslations } from "../decorators/with-translations"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag";
import {QUESTIONNAIRE_FRAGMENT} from "../graphql/fragments";

const query = gql`
  query LandingPage($languageCode: String) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;
export default compose(
  withTranslations,
  withRouter,
  withData(query, { forceFetch: false, options: getVariables }),
  connect(null, null)
)(LandingPage);



// WEBPACK FOOTER //
// ./src/containers/landing-page.js